import { fetchAuthSession } from 'aws-amplify/auth';
import moment from 'moment-timezone';

interface TokenExpirationResult {
  idToken: string;
  accessToken: string;
}

export const checkTokenExpiration = async (): Promise<TokenExpirationResult | null> => {
  try {
    const session = await fetchAuthSession();

    // Check if tokens exist
    if (!session.tokens) {
      console.error('No tokens found in session');
      return null;
    }

    // Get expiration from token payload
    const idTokenExpiration = session.tokens.idToken?.payload.exp;
    const accessTokenExpiration = session.tokens.accessToken?.payload.exp;

    if (!idTokenExpiration || !accessTokenExpiration) {
      console.error('Token expiration not found');
      return null;
    }

    const formatExpiration = (expirationTime: number) => {
      return moment(expirationTime * 1000)
        .local()
        .format('YYYY-MM-DD HH:mm:ss');
    };

    return {
      idToken: formatExpiration(idTokenExpiration),
      accessToken: formatExpiration(accessTokenExpiration)
    };
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return null;
  }
};
